exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".eyedropper {\n  font-size: 20px;\n  border-color: #444;\n  border-radius: 3px;\n  border-width: 1px;\n  border-style: solid;\n  cursor: pointer; }\n\n.eyedropSelected {\n  border-color: #22aa22;\n  color: #22aa22; }\n\n.cuadroColor {\n  height: 50px;\n  border-radius: 3px;\n  width: 50px;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioSeccion.component.scss
// module id = ../../../../../src/app/formularios/FormularioSeccion.component.scss
// module chunks = main